import React from 'react';
import { Paper } from '@mui/material';

const StandardFiltersBar = ({ children, sx = {} }) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        borderRadius: 2,
        p: { xs: 1, sm: 1.5 },
        mb: 2.5,
        bgcolor: 'background.paper',
        borderColor: 'divider',
        width: '100%',
        ...sx,
      }}
    >
      {children}
    </Paper>
  );
};

export default StandardFiltersBar;
